export const reportingQueryKeys = {
  all: ['reporting'] as const,
  agentSalesLive: (startAt: string, endAt: string, limit?: number) =>
    [...reportingQueryKeys.all, 'sales-live', 'agent-sales', startAt, endAt, limit] as const,
  aiSummaryStats: () => [...reportingQueryKeys.all, 'genesys-call-summary-stats'] as const,
  csDashboardCallDynamicsStats: (
    agentName: string | null | undefined,
    last7DaysStartAt: string,
    last7DaysEndAt: string,
    monthStartAt: string,
    monthEndAt: string,
    limit?: number,
  ) =>
    [
      ...reportingQueryKeys.all,
      'cs-dashboard-call-dynamics-stats',
      agentName,
      last7DaysStartAt,
      last7DaysEndAt,
      monthStartAt,
      monthEndAt,
      limit,
    ] as const,
  csDashboardStats: (featureIds: string[], startAt?: string, endAt?: string) =>
    [...reportingQueryKeys.all, 'cs-dashboard-stats', featureIds, startAt, endAt] as const,
  csAgentRoster: () => [...reportingQueryKeys.all, 'cs-agent-roster'] as const,
};
